import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'glxy-blank-value',
  template: ` <div class="symbol">—</div> `,
  styleUrls: ['./blank-value.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class BlankValueComponent {}

@Component({
  selector: 'glxy-blank-value-renderer',
  template: ` <glxy-blank-value /> `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BlankValueComponent],
})
export class BlankValueRendererComponent {}
